import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WebsitePreviousOrNextContentComponent } from './website-previous-or-next-content.component'
import { SharedModule } from '../shared/shared.module'



@NgModule({
  declarations: [WebsitePreviousOrNextContentComponent],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [WebsitePreviousOrNextContentComponent]
})
export class WebsitePreviousOrNextContentModule { }
